import { Injectable } from '@angular/core';
import { Headers, Request, Response, RequestMethod, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { HttpHelper } from '../../common/helpers/http.helper';
import { AddMember } from '../models/my-company/add-member.model';
import { AddCustomerAgreement } from '../models/my-company/add-customer-agreement.model';
import { RoleDc } from '../models/my-company/role-dc.model';
import { String } from '../../common/helpers/string.helper';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';
import { ContactFileInformationDc } from '../models/contact/contact-file-information-dc.model';
import { SessionHelper } from '../../common/helpers/session.helper';

@Injectable()
export class EmployeeService {
    public fileInformation = new BehaviorSubject(new ContactFileInformationDc());
    userProfileDetail: any;
    static currentUserDetail: any;
    private encryptSecretKey = "A<K9A>@HNS^Mjfu";
    constructor(private _httpHelper: HttpHelper) {
    }

    public getMyCompanyProfile(authenticationId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/getProfile?userId=" + authenticationId; //+ "&userName=" + UserName;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmployeeList(isActive: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/getTeamList/" + isActive;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmployeeNameList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/getemployeenamelist";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getEmployeeDetailByEmployeeId(employeeId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/details/" + employeeId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmployeeListByRoleId(roleid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/employeelistbyroleid/" + roleid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateTeamMember(addMember: AddMember) {
        let file: any = [];
        if (typeof addMember.ProfileImg === 'object') {
            file = addMember.ProfileImg;
            addMember.ProfileImg = "";
        }
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addMember));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "employee/AddUpdateTeam"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public DeleteEmployeeByEmployeeId(employeeId: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "employee/delete/" + employeeId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getRoleList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        //let url = "employee/employeerole/getRoleList";
        let url = "role/getallroles";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateRole(rolePermission: RoleDc) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "employee/employeerole/AddUpdateRoleMaster"
        return this._httpHelper.post(environment.APIBaseUrl + url, rolePermission, reqOption);
    }

    public deleteRole(roleId: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "employee/employeerole/delete/" + roleId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getRoleDetail(roleId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employeerole/details/" + roleId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateCompanyMaster(CompanyProfile: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "employee/AddUpdateCompanyProfile"
        return this._httpHelper.post(environment.APIBaseUrl + url, CompanyProfile, reqOption);
    }

    public getCompanyProfile(userId: Number, emailId: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/getProfile?userId=" + userId + "&userName=" + emailId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getPermissionListByRoleId(roleId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "rolepermission/permissionlist/getpermissiondetails/" + roleId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getActivityInModule() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "rolepermission/permissionlist/activityinmoduledetails/";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getActivityMasterByActivityID(activityid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "rolepermission/permissionlist/activitymasterdetails/" + activityid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public getModuleMasterList() {

        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "rolepermission/permissionlist/modulemasterdetails";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdatePermission(roleId: Number, rolePermissionId: Number, AddActivityIdsList: String) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "rolepermission/permissionlist/addupatepermissionmaster?RoleId=" + roleId + "&PermissionInEmployeeRolesId=" + rolePermissionId + "&AddActivityIdsList=" + AddActivityIdsList;
        return this._httpHelper.post(environment.APIBaseUrl + url, null, reqOption);
    }



    public addNewRole(role: RoleDc) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "role/addrole";
        return this._httpHelper.post(environment.APIBaseUrl + url, role, reqOption);
    }

    ///////////////////////////
    //    Branch Information //
    ///////////////////////////
    public getBranchInformationByCompanyId(companyid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/branchinformation/details/" + companyid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getBranchInformationByBranchId(branchid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/branchinformation/detailsbybranchid/" + branchid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteBranchInformationById(branchid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/branchinformation/delete/" + branchid;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateBranchInformation(branchinformation: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "employee/branchinformation/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, branchinformation, reqOption);
    }

    public editRole(roleInformation) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "role/editrole";
        return this._httpHelper.put(environment.APIBaseUrl + url, roleInformation, reqOption);
    }

    public getFullRoleInformationByRoleId(roleId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `role/getrolebyid/${roleId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    //New created by Rushabh
    public deleteUserRole(roleId) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = `role/deleterole?RoleId=${roleId}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    //Set user profile detail
    public setUserProfileDetail(profileDetail) {
        this.userProfileDetail = profileDetail;
        let userProfileDetails = CryptoJS.AES.encrypt(JSON.stringify(profileDetail), this.encryptSecretKey).toString();
        localStorage.setItem('UserDetails', userProfileDetails);
        //SessionHelper.setUserProfileDetail(profileDetail);
    }

    //Get user profile detail
    public getUserProfileDetail() {
        //return (this.userProfileDetail) ? this.userProfileDetail : false;
        let profileDetails = localStorage.getItem('UserDetails') ? localStorage.getItem('UserDetails') : false;
        if (profileDetails) {
            const bytes = CryptoJS.AES.decrypt(profileDetails, this.encryptSecretKey);
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            } else {
                return this.userProfileDetail;
            }
        } else {
            return this.userProfileDetail;
        }
    }


   


    //Add Update Logo
    public addUpdatePortalLogo(addUpdateMember: any) {
        let file: FormData = addUpdateMember.PortalLogo;
        delete addUpdateMember['PortalLogo'];
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addUpdateMember));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "employee/AddUpdatePortalLogo"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    //Add Update Banner
    public addUpdatePortalBanner(addUpdateMember: any) {
        let file: FormData = addUpdateMember.PortalBanner;
        delete addUpdateMember['PortalBanner'];
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addUpdateMember));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "employee/AddUpdatePortalBanner"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }


    public checkIsUserDeleted(userId: number, userType: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `user/IsUserDeleted?UserId=${userId}&UserType=${userType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    //Add Update EmailSignature 
    public addUpdateEmailSignature(addUpdateMember: any) {
        let file: FormData = addUpdateMember.EmailSignature;
        delete addUpdateMember['EmailSignature'];
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addUpdateMember));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "employee/AddUpdateEmailSignature"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public getEmployeeListBySearch(isActive: number, programId: number){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `employee/getTeamList?isActive=${isActive}&programId=${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/services/employee.service.ts